import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ManageContentAssociations = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const navigate = useNavigate();

  const [contentAssociationTypes, setContentAssociationTypes] = useState([]);

  const [state, setState] = useState({
    contentAssociationId: parseInt(parms.get("id")),
    contentId: 0,
    contentAssociationTypeId: 0,
    contentAssociationName: "",
    contentAssociationDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-associations/${state.contentAssociationId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentAssociationId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-association-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentAssociationTypes = res.data;
        console.log(contentAssociationTypes);
        setContentAssociationTypes(contentAssociationTypes);
      });

    console.log("handleOnLoad() - loading id = " + state.contentAssociationId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-associations/${state.contentAssociationId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentAssociationId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-associations/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Association</h4>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Choose Association">
            Choose Association
          </label>
          <select
            onchange="submit()"
            id="content_association_id"
            className="form-control input-xlarge col-sm-8"
            value="#{contentAssociationForm.currentContentAssociation.contentAssociationId}"
            valueChangeListener="#{contentAssociationForm.get}"
          >
            <option value="#{contentAssociationForm.contentAssociationSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            id="contentId"
            readOnly={true}
            id="content_name"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Association Type">
            Associations Type
          </label>
          <select
            id="contentAssociationTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeId}
            onChange={handleChange}
          >
            <option>Select Association Type</option>
            {contentAssociationTypes.map(
              ({ contentAssociationTypeName, contentAssociationTypeId }) => (
                <option
                  key={contentAssociationTypeId}
                  value={contentAssociationTypeId}
                >
                  {contentAssociationTypeName}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Association Object">
            Association Object Name
          </label>
          <input
            id="contentAssociationName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentAssociationDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationDescr}
            onChange={handleChange}
          >
            {" "}
          </textarea>
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        {/* <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{contentAssociationForm.clear}"
        >
          Clear
        </button>
        &nbsp; */}
                <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          {" "}
          Save
        </button>

      </div>
    </form>
  );
};

export default ManageContentAssociations;
